import type {AddComponentTypeOptions} from 'grapesjs';
import {createBaseSelectComponent} from '@FormMakerReact/components/create-base-input-component';
import {FORM_INPUT_STYLES} from '@FormMakerReact/components/component-styles';

export const POSTERMYWALL_STATE_INPUT_TYPE = 'postermywall-state-input';
const STATE_OPTIONS = '<option value="placeholder" disabled selected>Select state/province</option>';

export const POSTERMYWALL_STATE_INPUT: AddComponentTypeOptions = createBaseSelectComponent({
  inputFieldType: POSTERMYWALL_STATE_INPUT_TYPE,
  inputName: 'state',
  dataMarkerAttribute: 'data-is-pmw-form-state-select',
  displayName: window.i18next.t('pmwjs_state'),
  style: FORM_INPUT_STYLES,
  isComponentCheck: (el) => el.getAttribute('data-is-pmw-form-state-select') !== null,
  defaultOptionsHtml: STATE_OPTIONS,
});
